import React, { lazy } from 'react';

import { Route, Routes } from 'react-router-dom';

const ServiceNowIntegrationPage = lazy(
  () => import('./service-now-integration.page'),
);

export const ServiceNowRoutes = () => {
  return (
    <Routes>
      <Route index element={<ServiceNowIntegrationPage isOnboarded />} />
      <Route
        path="new"
        element={<ServiceNowIntegrationPage isOnboarded={false} />}
      />
    </Routes>
  );
};
